/*
================================================================ 
		 Copyright (c) 2018-2021 Digitize Things Inc.           
					 All rights reserved.                       
================================================================ 
*/
import { connect } from "react-redux";
import React, { useEffect, useState, useRef } from "react";
import { withTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import ConfigurationResource from "../component/configurationResource";
import Draggable from "react-draggable";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import actionTypes from "../../../store/actions";
import { Paper } from "@mui/material";
import { Tooltip } from "@mui/material";
// import { makeStyles } from '@mui/styles';

const ViewProductDetails = (props) => {
  const t = props.t;

  useEffect(() => {
    setProductResources();
  }, []);
  // const styles = makeStyles({
  // 	resizablePaper: {
  // 		resize: 'both',
  // 		overflow: 'auto',
  // 		minWidth: 640,
  // 		minHeight: 200,
  // 		maxWidth: '90vw',
  // 		maxHeight: '90vh',
  // 		width: '60vw',
  // 	},
  // });
  // const jssClasses = styles();
  const [render, renderResources] = useState(false);

  // resources list
  const [resources, setResources] = useState({});

  const [showDefaultValue, setShowDefaultValue] = useState(false);

  const [fulfilment, setFulfilment] = useState({
    selectedFulfilmentResource: {},
    fulfilmentConnectionFields: {},
    fulfilmentTableFields: [],
    fulfilmentTableEditable: false,
  });

  const [activation, setActivation] = useState({
    selectedActivationResource: {},
    activationConnectionFields: {},
    activationTableFields: [],
    activationTableEditable: false,
    activationFile: "",
  });

  const [suspend, setSuspend] = useState({
    selectedSuspendResource: {},
    suspendConnectionFields: {},
    suspendTableFields: [],
    suspendTableEditable: false,
  });

  const [resume, setResume] = useState({
    selectedResumeResource: {},
    resumeConnectionFields: {},
    resumeTableFields: [],
    resumeTableEditable: false,
  });

  const setProductResources = () => {
    var item = { ...props.product };
    var selectedFulfilmentResource = {};
    var selectedActivationResource = {};
    var selectedSuspendResource = {};
    var selectedResumeResource = {};

    var tempProvisioning = {};
    if (item.provisioning && item.provisioning.resourceId) {
      selectedFulfilmentResource = props.provisioningResources.find(
        (x) => x.resourceId === item.provisioning.resourceId,
      );
      if (selectedFulfilmentResource) {
        selectedFulfilmentResource.targetAddress =
          item.provisioning.targetAddress;
        if (item.provisioning.extraFields) {
          tempProvisioning["fulfilmentConnectionFields"] =
            item.provisioning.extraFields;
        }
        if (item.provisioning.parameters) {
          tempProvisioning["fulfilmentTableFields"] = JSON.parse(
            item.provisioning.parameters,
          );
        }
        if ("STD_VM_PROV" === item.provisioning.resourceId) {
          setShowDefaultValue(true);
        }
      }
    }
    var tempActivation = {};
    if (item.activation && item.activation.resourceId) {
      selectedActivationResource = props.activationResources.find(
        (x) => x.resourceId === item.activation.resourceId,
      );
      if (selectedActivationResource) {
        selectedActivationResource.targetAddress =
          item.activation.targetAddress;
        if (item.activation.extraFields) {
          tempActivation["activationConnectionFields"] =
            item.activation.extraFields;
        }
        if (item.activation.parameters) {
          tempActivation["activationTableFields"] = JSON.parse(
            item.activation.parameters,
          );
        }
      }
    }
    var tempSuspend = {};
    if (item.suspendResource && item.suspendResource.resourceId) {
      selectedSuspendResource = props.suspendResources.find(
        (x) => x.resourceId === item.suspendResource.resourceId,
      );
      if (selectedSuspendResource) {
        selectedSuspendResource.targetAddress =
          item.suspendResource.targetAddress;
        if (item.suspendResource.extraFields) {
          tempSuspend["suspendConnectionFields"] =
            item.suspendResource.extraFields;
        }
        if (item.suspendResource.parameters) {
          tempSuspend["suspendTableFields"] = JSON.parse(
            item.suspendResource.parameters,
          );
        }
      }
    }
    var tempResume = {};
    if (item.resumeResource && item.resumeResource.resourceId) {
      selectedResumeResource = props.resumeResources.find(
        (x) => x.resourceId === item.resumeResource.resourceId,
      );
      if (selectedResumeResource) {
        selectedResumeResource.targetAddress =
          item.resumeResource.targetAddress;
        if (item.resumeResource.extraFields) {
          tempResume["resumeConnectionFields"] =
            item.resumeResource.extraFields;
        }
        if (item.resumeResource.parameters) {
          tempResume["resumeTableFields"] = JSON.parse(
            item.resumeResource.parameters,
          );
        }
      }
    }
    tempProvisioning["selectedFulfilmentResource"] = selectedFulfilmentResource
      ? selectedFulfilmentResource
      : {};
    tempActivation["selectedActivationResource"] = selectedActivationResource
      ? selectedActivationResource
      : {};
    tempSuspend["selectedSuspendResource"] = selectedSuspendResource
      ? selectedSuspendResource
      : {};
    tempResume["selectedResumeResource"] = selectedResumeResource
      ? selectedResumeResource
      : {};

    setFulfilment({
      ...fulfilment,
      ...tempProvisioning,
    });
    setActivation({
      ...activation,
      ...tempActivation,
    });
    setSuspend({
      ...suspend,
      ...tempSuspend,
    });
    setResume({
      ...resume,
      ...tempResume,
    });
    renderResources(true);
  };

  return (
    <Dialog
      disableScrollLock={true}
      maxWidth={"lg"}
      fullWidth={true}
      open={props.showProductDetails}
      aria-labelledby="importKitPaper"
      PaperComponent={ImportKitPaper}
      // PaperProps={{
      // 	className: jssClasses.resizablePaper
      // }}
    >
      <DialogTitle id="importKitPaper" style={{ cursor: "move" }}>
        <div style={{ display: "flex" }}>
          <span style={{ display: "inline-flex", width: "100%" }}>
            {t("VIEW_PRODUCT")}: {props.product.name}
          </span>
          <Tooltip title={t("CLOSE")}>
            <IconButton
              onTouchStart={(event) => {
                props.setProductDetails({});
                props.closeProductDetailsDialog(false);
              }}
              onClick={(event) => {
                props.setProductDetails({});
                props.closeProductDetailsDialog(false);
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        {render && (
          <ConfigurationResource
            // provising data
            provisioningResources={props.provisioningResources}
            fulfilmentConnectionFields={fulfilment.fulfilmentConnectionFields}
            fulfilmentTableFields={fulfilment.fulfilmentTableFields}
            fulfilmentTableEditable={fulfilment.fulfilmentTableEditable}
            showDefaultValue={showDefaultValue}
            selectedFulfilmentResource={fulfilment.selectedFulfilmentResource}
            // activation data
            activationResources={props.activationResources}
            activationConnectionFields={activation.activationConnectionFields}
            activationTableFields={activation.activationTableFields}
            activationTableEditable={activation.activationTableEditable}
            activationFile={activation.activationFile}
            selectedActivationResource={activation.selectedActivationResource}
            // Suspend resource
            suspendResources={props.suspendResources}
            suspendConnectionFields={suspend.suspendConnectionFields}
            suspendTableFields={suspend.suspendTableFields}
            suspendTableEditable={suspend.suspendTableEditable}
            selectedSuspendResource={suspend.selectedSuspendResource}
            // Resume resource
            resumeResources={props.resumeResources}
            resumeConnectionFields={resume.resumeConnectionFields}
            resumeTableFields={resume.resumeTableFields}
            resumeTableEditable={resume.resumeTableEditable}
            selectedResumeResource={resume.selectedResumeResource}
            priceType={props.product.priceType}
            readonly={true}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

const ImportKitPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#importKitPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {
    enabledModules: state.auth.enabledModules,
    permissions: state.auth.userPerms,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ViewProductDetails));
